
import { useEffect } from 'react';
import { useAuth } from '@/hooks/use-auth';
import { Navigate } from 'react-router-dom';

/**
 * AuthGuard redirects authenticated users away from auth pages 
 * like login and signup
 */
const AuthGuard = ({ children }: { children: React.ReactNode }) => {
  const { user, loading } = useAuth();

  // If user is authenticated, redirect to marketplace
  if (user && !loading) {
    return <Navigate to="/marketplace" replace />;
  }
  
  // If still loading or user not authenticated, show the auth page
  return <>{children}</>;
};

export default AuthGuard;
